import { render, staticRenderFns } from "./PanelWithTagsEditor.vue?vue&type=template&id=e0b1a91e&lang=pug&"
import script from "./PanelWithTagsEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithTagsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithTagsEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports